<template>
  <!-- 表格 -->
  <div style="">
    <el-row style>
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24"
              style="line-height:40px;height:40px;margin-bottom:10px;background-color:#042340;text-align: center;margin-right: 10px;">
        {{ form.name }}
      </el-col>
    </el-row>
    <el-table
      :cell-class-name="tableCellClassName"
      :data="dataList"
      :height="tableHeight"
      :row-class-name="tableRowClassName"
      border
      style="width: 100%;overflow-y: scroll;"
      @selection-change="changeCheckBoxValue">
      <el-table-column
        type="selection">
      </el-table-column>
      <el-table-column
        align="center"
        label="测点名称"
        prop="contractNum"
        width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="告警类型"
        prop="contractNum"
        width="150">
        <template slot-scope="scope">
                    <span
                      v-if="editorList[scope.row.index] == scope.row.index || (batchOperation && indexList[scope.row.index] == scope.row.index)">
                        <el-select
                          v-model="scope.row.alarmType"
                          collapse-tags
                          placeholder="请选择"
                          size="mini"
                          style="padding-bottom: 5px;width: 100%">
                        <el-option
                          v-for="item in alarmType"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </span>
          <span
            v-if="editorList[scope.row.index] !== scope.row.index && !(batchOperation && indexList[scope.row.index] == scope.row.index)">{{
              scope.row.alarmTypeName
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="告警基值"
        prop="contractNum">
        <template slot-scope="scope">
                    <span
                      v-if="editorList[scope.row.index] == scope.row.index || (batchOperation && indexList[scope.row.index] == scope.row.index)">
                        <el-input v-model="scope.row.alarmBasic" size="mini"
                                  @input="input(scope.row.alarmBasic,'alarmBasic')"/>
                    </span>
          <span
            v-if="editorList[scope.row.index] !== scope.row.index && !(batchOperation && indexList[scope.row.index] == scope.row.index)">{{
              scope.row.alarmBasic
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="告警上限"
        prop="contractNum">
        <template slot-scope="scope">
                    <span
                      v-if="editorList[scope.row.index] == scope.row.index || (batchOperation && indexList[scope.row.index] == scope.row.index)">
                        <el-input v-model="scope.row.alarmHigh" size="mini"
                                  @input="input(scope.row.alarmHigh,'alarmHigh')"/>
                    </span>
          <span
            v-if="editorList[scope.row.index] !== scope.row.index && !(batchOperation && indexList[scope.row.index] == scope.row.index)">{{
              scope.row.alarmHigh
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="恢复上限"
        prop="contractNum">
        <template slot-scope="scope">
                    <span
                      v-if="editorList[scope.row.index] == scope.row.index|| (batchOperation && indexList[scope.row.index] == scope.row.index)">
                        <el-input v-model="scope.row.alarmRecoverHigh" size="mini"
                                  @input="input(scope.row.alarmRecoverHigh,'alarmRecoverHigh')"/>
                    </span>
          <span
            v-if="editorList[scope.row.index] !== scope.row.index && !(batchOperation && indexList[scope.row.index] == scope.row.index)">{{
              scope.row.alarmRecoverHigh
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="告警下限"
        prop="contractNum">
        <template slot-scope="scope">
                    <span
                      v-if="editorList[scope.row.index] == scope.row.index|| (batchOperation && indexList[scope.row.index] == scope.row.index)">
                        <el-input v-model="scope.row.alarmLow" size="mini"
                                  @input="input(scope.row.alarmLow,'alarmLow')"/>
                    </span>
          <span
            v-if="editorList[scope.row.index] !== scope.row.index && !(batchOperation && indexList[scope.row.index] == scope.row.index)">{{
              scope.row.alarmLow
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="恢复下限"
        prop="contractNum">
        <template slot-scope="scope">
                    <span
                      v-if="editorList[scope.row.index] === scope.row.index|| (batchOperation && indexList[scope.row.index] == scope.row.index)">
                        <el-input v-model="scope.row.alarmRecoverLow" size="mini"
                                  @input="input(scope.row.alarmRecoverLow,'alarmRecoverLow')"/>
                    </span>
          <span
            v-if="editorList[scope.row.index] !== scope.row.index && !(batchOperation && indexList[scope.row.index] == scope.row.index)">{{
              scope.row.alarmRecoverLow
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="百分比"
        prop="contractNum">
        <template slot-scope="scope">
                    <span
                      v-if="editorList[scope.row.index] === scope.row.index|| (batchOperation && indexList[scope.row.index] == scope.row.index)">
                        <el-input v-model="scope.row.alarmPercent" size="mini"
                                  @input="input(scope.row.alarmPercent,'alarmPercent')"/>
                    </span>
          <span
            v-if="editorList[scope.row.index] !== scope.row.index && !(batchOperation && indexList[scope.row.index] == scope.row.index)">{{
              scope.row.alarmPercent
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        width="180">
        <template slot-scope="scope">
          <div v-if="!batchOperation">
            <b-button v-if="editorList[scope.row.index] !== scope.row.index" style="color: #fdfdfd" variant="text"
            @touchstart="tabClick(scope.row,scope.column)"    @click="tabClick(scope.row,scope.column)">
              <img src="@/assets/images/icon/edit.png" style="margin-bottom: 4px;">
              <span style="margin-left: 4px;">编辑</span>
            </b-button>
            <b-button v-if="editorList[scope.row.index] === scope.row.index" style="color: #fdfdfd" variant="text"
                 @touchstart="saveClick(scope.row,scope.column)"     @click="saveClick(scope.row,scope.column)">
              <img src="@/assets/images/icon/save.png" style="margin-bottom: 4px;">
              <span style="margin-left: 4px;">保存</span>
            </b-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :lg="10" :md="10" :sm="10" :xl="10" :xs="10"
              style="height: 20px;line-height: 40px;text-align: left;margin-left: 40px;">
        批量操作
        <el-switch
          v-model="batchOperation"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @touchstart.native="shieldSwitch"
          @click.native="shieldSwitch">
        </el-switch>
      </el-col>
      <el-col :lg="3" :md="3" :sm="3" :xl="3" :xs="3"
              style="height: 20px;line-height: 40px;text-align: right;float: right;margin-right: 30px;">
        <b-button v-if="batchOperation" style="color: #fdfdfd" variant="text" @touchstart="updateDeviceMeasuringPointBatch" @click="updateDeviceMeasuringPointBatch">
          <img src="@/assets/images/icon/save.png" style="margin-bottom: 4px;">
          <span style="margin-left: 4px;">批量保存</span>
        </b-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <el-col :lg="10" :md="10" :sm="10" :xl="10" :xs="10"
              style="height: 20px;line-height: 20px;text-align: left;margin-left: 40px;">
        同步配置
        <el-switch v-model="isSYNC"
                   active-color="#13ce66"
                   inactive-color="#ff4949"
                   value="false">
        </el-switch>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="isSYNC" :lg="10" :md="10" :sm="10" :xl="10"
              :xs="10" style="height: 40px;line-height: 40px;text-align: left;margin-left: 40px;">
        <el-radio v-model="space" label="0" style="margin-top: 7px;">当前空间</el-radio>
        <el-radio v-model="space" label="1" style="margin-top: 7px;">全部空间</el-radio>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="isSYNC" :lg="10" :md="10" :sm="10" :xl="10"
              :xs="10" style="height: 30px;line-height: 30px;text-align: left;margin-left: 40px;">
        <el-checkbox v-model="sameModel" label="同型号所有设备"></el-checkbox>
        <el-checkbox v-model="sameKind" label="同类型所有设备"></el-checkbox>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="isSYNC" :lg="22" :md="22" :sm="22" :xl="22"
              :xs="22"
              style="height: 30px;line-height: 30px;text-align: left;margin-left: 40px;color:rgb(216, 228, 106);margin-top: 20px;font-size:10px;">
        备注：选择同步配置后，当前设备的参数配置将同步到对应的设备
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  listByDeviceId,
  updateDeviceMeasuringPointAlarm,
  updateDeviceMeasuringPointBatch
} from "@/network/device-measuring-point";

export default {
  name: "ThresholdValueList",
  props: {
    deviceInfo: {},
  },
  data() {
    return {
      indexList: [],
      isSYNC: false,
      // 同型号所有设备
      sameModel: false,
      // 同类型所有设备
      sameKind: false,
      batchOperation: false,
      space: '0',
      device: '',
      form: {
        name: this.deviceInfo.name,
        note: this.deviceInfo.note,
        id: this.deviceInfo.id
      },
      rowIndex: -1, //行索引
      columnIndex: -1, //列索引
      currentPage: 1,
      pageSize: 10,
      total: 0,
      height: window.innerHeight + 'px',
      theadList: [
        {name: '测点名称', value: 'name'},
        {name: '告警类型', value: 'alarmType'},
        {name: '告警基值', value: 'alarmBasic'},
        {name: '告警上限', value: 'alarmHigh'},
        {name: '恢复上限', value: 'alarmRecoverHigh'},
        {name: '告警下限', value: 'alarmLow'},
        {name: '恢复下限', value: 'alarmRecoverLow'},
        {name: '百分比', value: 'alarmPercent'},
      ],
      dataList: [],
      alarmType: [
        {name: '无告警', value: 0},
        {name: '绝对阈值', value: 1},
        {name: '百分比阈值', value: 2},
        {name: '上下限告警', value: 3},
      ],
      editorList: [],
    }
  },
  mounted() {
    this.listByDeviceId();
  },
  computed: {
    tableHeight() {
      if (this.dataList) {
        return window.innerHeight * 0.5;
      } else {
        return window.innerHeight * 0.2;
      }
    }
  },
  methods: {
    // 值变化
    input(value, name) {
      if (this.batchOperation) {
        for (let index of this.indexList) {
          if (index) {
            this.$set(this.dataList[index], name, value);
          }
        }
      }
    },
    // 点击每行前的框
    changeCheckBoxValue(val) {
      this.indexList = new Array(this.dataList.length);
      for (let i = 0; i < val.length; i++) {
        let index = val[i].index;
        this.indexList.splice(index, 1, index);
      }
    },
    // 点击批量操作
    shieldSwitch() {
      if (!this.batchOperation) {
        this.editorList = new Array(this.dataList.length);
      }
    },
    //把每一行的索引加到行数据中
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
    },
    //把每一列的索引加到列数据中
    tableCellClassName({column, columnIndex}) {
      column.index = columnIndex;
    },
    //单元格被点击时会触发该事件
    tabClick(row) {
      this.editorList.splice(row.index, 1, row.index);
    },
    // 保存
    saveClick(row) {
      row.alarmTypeName = row.alarmType === 0 ? '无告警' : row.alarmType === 1 ? '绝对阈值' : row.alarmType === 2 ? '百分比阈值' : '上下限告警';
      this.$confirm(this.promptMessage(), {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            // 关闭编辑框
            this.editorList.splice(row.index, 1, -1);
            row.isSYNC = this.isSYNC;
            row.isSameModel = this.sameModel;
            row.isSameKind = this.sameKind;
            row.isAllSpace = this.space != '0';
            this.updateDeviceMeasuringPoint(row);
          }
        }
      });
    },
    // 操作提示
    promptMessage() {
      let msg = "";
      if (this.isSYNC) {
        let space = this.space === '0' ? '当前' : '全部';
        if (this.sameModel && !this.sameKind) {
          // 同类不同型
          msg = "当前启用了同步配置，配置会同步到" + space + "空间，同型号所有设备";
        } else if (!this.sameModel && this.sameKind) {
          // 同型不同类
          msg = "当前启用了同步配置，配置会同步到" + space + "空间，同类型所有设备";
        } else if (this.sameModel && this.sameKind) {
          // 同型同类
          msg = "当前启用了同步配置，配置会同步到" + space + "空间，同类型及同型号所有设备";
        } else {
          msg = "当前启用了同步配置，配置将同步到主机";
        }
      } else {
        msg = "当前停用了同步配置，配置将不会进行同步";
      }
      return msg;
    },
    // 获取设备的测点列表
    listByDeviceId() {
      listByDeviceId(this.form.id).then(res => {
        if (res.data) {
          this.dataList = res.data;
          this.dataList.forEach((item) => {
            item.alarmTypeName = item.alarmType === 0 ? '无告警' : item.alarmType === 1 ? '绝对阈值' : item.alarmType === 2 ? '百分比阈值' : '上下限告警';
          });
          this.indexList = new Array(this.dataList.length);
          this.editorList = new Array(this.dataList.length);
        }
      });
    },
    // 执行修改
    updateDeviceMeasuringPoint(form) {
      updateDeviceMeasuringPointAlarm(form).then(res => {
        if (res.code === 0) {
          this.$message.success("操作成功!");
        } else {
          this.$message.error("操作失败!");
        }
        this.listByDeviceId();
      });
    },
    // 批量修改
    updateDeviceMeasuringPointBatch() {
      // 获取修改的值  直接根据下标获取
      let pointList = [];
      for (let size = 0; size < this.indexList.length; size++) {
        if (this.indexList[size] == size) {
          pointList.push(this.dataList[size]);
        }
      }
      let form = {
        pointList
      };
      form.isSYNC = this.isSYNC;
      form.isSameModel = this.sameModel;
      form.isSameKind = this.sameKind;
      form.isAllSpace = this.space != '0';
      // 前去保存数据
      updateDeviceMeasuringPointBatch(form).then(res => {
        if (res.code === 0) {
          this.$message.success("操作成功!");
        } else {
          this.$message.error("操作失败!");
        }
        this.listByDeviceId();
      });
    }
  }
}
</script>

<style scoped>

</style>
<style>
.el-radio {
  color: white;
}

.el-checkbox {
  color: white;
}
</style>
